<template>
  <v-page>
    <toolbar fixed>
      <template v-slot:left>
        <span class="v-toolbar__text">{{
          $t("pages.account.purchases.purchaseTitle")
        }}</span>
      </template>
    </toolbar>

    <list
      class="mt-1"
      :heading="$t('pages.account.purchases.purchaseHistory')"
      boxed
    >
      <template v-if="isLoading">
        <div class="d-flex align-items-center justify-content-center py-5">
          <v-loader />
        </div>
      </template>
      <template v-else-if="purchases.length > 0">
        <list-item v-for="purchase in purchases" :key="purchase.id">
          <span class="v-list-item__title">
            {{ purchase.product.title }}
          </span>
          <template slot="right">
            <template v-if="isSubscription(purchase)">
              <v-icon icon="autorenew" />
            </template>
          </template>
          <template slot="row">
            <template v-if="purchase.is_iap_purchase">
              <v-button small secondary class="ml-0" @click="openIapManager">
                {{ $t("pages.account.purchases.purchaseView") }}
              </v-button>
            </template>
            <template v-else>
              <div class="w-50 mt-1">
                <v-button
                  small
                  secondary
                  class="ml-0"
                  :to="purchase.invoice_url"
                >
                  {{ $t("pages.account.purchases.purchaseViewReceipt") }}
                </v-button>
              </div>
              <div
                class="w-50 mt-1 d-flex align-items-center justify-content-end"
              >
                <strong
                  >{{ purchase.amount.symbol
                  }}{{ purchase.amount.amount }}</strong
                >
                <span
                  class="text-small opacity-70"
                  style="margin-left: 0.25rem;"
                >
                  &nbsp;{{ purchase.amount.currency }}
                </span>
              </div>
            </template>
          </template>
        </list-item>
      </template>
      <template v-else>
        <list-item>
          <template slot="left">
            <span class="v-list-item__title">
              {{ $t("pages.account.purchases.noPurchasesShow") }}
            </span>
          </template>
        </list-item>
      </template>
    </list>
  </v-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import { openIapManager } from "@/lib/app-store-utils"

import Toolbar from "@/components/Toolbar"
import List from "@/components/List"
import ListItem from "@/components/ListItem"

export default {
  components: {
    Toolbar,
    List,
    ListItem
  },

  data() {
    return {
      isLoading: true,
      purchases: []
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"])
  },

  watch: {
    isAuthenticated: {
      immediate: true,
      handler: function() {
        if (this.isAuthenticated) {
          this.fetchAccountPurchases().then(res => {
            this.isLoading = false

            this.purchases = res.purchases
          })
        }
      }
    }
  },

  methods: {
    openIapManager,

    ...mapActions("auth", ["fetchAccountPurchases"]),

    isSubscription(purchase) {
      return purchase.product.purchase_type === "recurring"
    }
  }
}
</script>
